// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switch-swrapper[data-v-c36d52a6]{height:35px;width:60px;border-radius:25px;position:relative}.slider[data-v-c36d52a6]{position:absolute;margin:2px 2px 2px 2px;width:26px;height:26px;border-radius:50%}", ""]);
// Exports
module.exports = exports;
